import React, { useCallback } from 'react';

export default function ControlledMiniForm({
  children,
  onSubmit,
  onCancel = null,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  submitDisabled = false,
  showCancel = false,
  style,
  actionsStyle,
  submitButtonStyle,
  cancelButtonStyle,
  submitButtonProps,
  cancelButtonProps,
  ...rest
}) {
  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    onSubmit?.(event);
  }, [onSubmit]);

  const handleCancel = useCallback((event) => {
    event.preventDefault();
    onCancel?.(event);
  }, [onCancel]);

  return (
    <form {...rest} onSubmit={handleSubmit} style={style}>
      {children}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          ...actionsStyle,
        }}
      >
        {showCancel && (
          <button
            type="button"
            onClick={handleCancel}
            style={cancelButtonStyle}
            {...cancelButtonProps}
          >
            {cancelLabel}
          </button>
        )}
        <button
          type="submit"
          disabled={submitDisabled}
          style={submitButtonStyle}
          {...submitButtonProps}
        >
          {submitLabel}
        </button>
      </div>
    </form>
  );
}
